export default "__VITE_ASSET__$vGAht_0__"